import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PhotoPrintsJson } from '@ff-scene-plugins/photo-prints-shared/PhotoPrintsJson';

export const { actions, reducer } = createSlice({

    name: 'quality',

    initialState: 'standard' as PhotoPrintsJson.PrintQuality,

    reducers: {
        overwrite: (state, action: PayloadAction<PhotoPrintsJson.PrintQuality>) => {
            return action.payload;
        }
    }
});